import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { ShareLinkIcon, Tooltip } from "@flat-ui";
import { ProjectShareDialog } from "@pages/projects/project-share-dialog";
import { ProjectEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
/** Renders share project button that wraps with project share dialog */
export function ShareProjectButton(t0) {
  const $ = _c(11);
  const {
    project,
    location
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] !== location || $[1] !== project.id || $[2] !== trackEvent) {
    t1 = function onClick() {
      setIsDialogOpen(true);
      trackEvent({
        name: ProjectEvents.openShareProject,
        props: {
          projectId: project.id,
          location
        }
      });
    };
    $[0] = location;
    $[1] = project.id;
    $[2] = trackEvent;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onClick = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsDialogOpen(false);
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onClick) {
    t3 = <Tooltip component="div" title="Share project"><SphereIconButton component={ShareLinkIcon} onClick={onClick} /></Tooltip>;
    $[5] = onClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isDialogOpen || $[8] !== project || $[9] !== t3) {
    t4 = <ProjectShareDialog project={project} isOpen={isDialogOpen} onClose={t2}>{t3}</ProjectShareDialog>;
    $[7] = isDialogOpen;
    $[8] = project;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}